import React from "react";
import { SampleRequestDetailPage } from "../../SharedPages/SampleRequestDetailPage/SampleRequestDetailPage";

/**
 * The Sample Request detail page that displays a single sample request.
 */
export const SellerSampleRequestDetail = () => {
  return <SampleRequestDetailPage />;
};
